(function () {

    if (template == "product" || template == "cart") {
        //for the product page and cart page quantity button
        const quantityButton = document.querySelectorAll(".quantity__button");
        //delegation function
        const delegate = (selector, eventType, childSelector, eventHandler) => {
            const elements = document.querySelectorAll(selector);
            const multiEvent = eventType.split(',');
            for (element of elements) {
                multiEvent.forEach(evt => {
                    element.addEventListener(evt.trim(), eventOnElement => {
                        (eventOnElement.target.matches(childSelector)) ? eventHandler(eventOnElement) : '';
                    });
                });
            }
        }

        delegate("body", "click", ".quantity__button", event => {
            let quantityValue = document.querySelector(".quantity__input");
            let attr = event.target.getAttribute("name");
            if (attr == "plus") {
                if (quantityValue.value > 10) {
                    if (quantityValue.value >= 50) {
                        quantityValue.value = 50;
                        alert("You can add only upto 50 quantity");
                    }
                    else {
                        quantityValue.value = Number(quantityValue.value) + 4;
                    }
                }
            }
            else if (attr == "minus") {
                if (quantityValue.value > 10) {
                    quantityValue.value = Number(quantityValue.value) - 4;
                }
            }
        });
    }
})();